import { useDatabase } from "@nozbe/watermelondb/hooks";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useEffect, useState } from "react";
import { Text, View } from "react-native-ui-lib";
import { FlatActionList } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { ReceiptModalRootParmList } from "../../../../types";
import ReceiptTemplate from "../../../../utilities/data/model/ReceiptTemplate";
import { useReceiptsController } from "../../../../utilities/receipt";
import { usePrintReceipt } from "../../../../utilities/receipt/use-print-receipt.web";
import { useSaleContextProvider } from "../../utils";
import { useTranslation } from "../../../../utilities/i18n";

export type PrintReceiptModalScreenProps = NativeStackScreenProps<
  ReceiptModalRootParmList,
  "PrintReceiptModalScreen"
>;

// this will only work for web , mobile will need to use a different approach
export const PrintReceiptModalScreen = ({
  navigation,
  route,
}: PrintReceiptModalScreenProps) => {
  const {t } = useTranslation("sales")
  const { sale } = useSaleContextProvider();

  const { handleOnPrintReceipt } = usePrintReceipt({
    controller: useReceiptsController(),
  });

  const [receiptTemplates, setReceiptTemplates] = useState<
    ReceiptTemplate[] | undefined
  >();

  const database = useDatabase();

  useEffect(() => {
    database
      .get<ReceiptTemplate>("receipt_template")
      .query()
      .fetch()
      .then((i) => setReceiptTemplates(i));
  }, []);

  const items =
    receiptTemplates?.map((i) => ({
      key: i.id,
      title: i.name,
      subTitle: i.receiptTemplateType.id,
      onPress: () =>
        sale &&
        handleOnPrintReceipt(sale, i, {
          afterPrint: async () => navigation.getParent()?.goBack(),
        }),
    })) || [];

  const noContentMarkup =
    receiptTemplates !== undefined && receiptTemplates.length == 0 ? (
      <Text>{t("no_receipt_template")}</Text>
    ) : undefined;

  return (
    <Page>
      <View>
        {noContentMarkup}
        {sale ? <FlatActionList items={items} /> : undefined}
      </View>
    </Page>
  );
};
